module.exports = __webpack_public_path__ + "img/img_xinshou_7.72e92c57.png";